<template>
  <div>
      <div class="banner"></div>
      <div>
        <div class="main clearfix">
          <div style="margin-bottom: 80px; display: flex; justify-content: center;" class="clearfix">
            <div style="float: left;width: 617px; height: 425px;"><img style="width: 100%; height: 100%;" src="//static.yiteng288.com/e-comm/pages/winsway/public/160341972152101099831_1234_850.png" alt=""></div>
            <div style="width: 346px; margin-left: 100px; position: relative; padding-top: 87px;">
              <p style="color: #27253A; font-size: 24px; text-align: left; margin-bottom: 10px;">毅腾物流园区</p>
              <div><img style="width: 285px; height: 48px; position: absolute; left: -44px;" src="//static.yiteng288.com/e-comm/pages/winsway/public/160341972164645190180_570_96.png" alt=""></div>
              <p style="color: rgb(107, 107, 129);font-size: 14px;text-align: left;padding-bottom: 25px;margin-top: 44px; line-height: 24px;">毅腾物流园区将物联网、AI等技术手段，充分应用到整个仓储作业、运输服务及园区管理中，打造智能、安全、高效的智慧物流园区，并以园区为核心，实现了集运输、仓库、检验检疫、监管等各方的协同化，打破信息孤岛，提升物流服务水平和监管标准。</p>
              <div style="width: 240px; height: 1px; background: #EA5714;"></div>
            </div>
          </div>
          <div style="display: flex; clear: both;">
            <div class="owl-item">
              <a href="//login.yiteng288.com/saaslogin/index" target="_blank">
                <div class="pic">
                  <img class="big_pic" src="//static.yiteng288.com/e-comm/pages/winsway/public/160341972243246943579_768_456.png" alt="">
                  <img src="//static.yiteng288.com/e-comm/pages/winsway/public/160341972182925250808_152_152.png" class="icon" alt="">
                </div>
                <div style="padding: 40px 20px;">
                  <div>
                    <p style="font-size: 24px; text-align: left; color: #262634;">货主服务 — <span style="font-size: 16px;">业务全程在线</span></p>
                  </div>
                  <div style="margin-top: 20px;display: flex;justify-content: space-between;align-items: flex-end;">
                    <ul class="wisdom-list">
                      <li class="clearfix" style="margin-bottom: 5px;">
                        <p class="fl">入驻</p>
                        <p class="fr">在线结算</p>
                      </li>
                      <li class="clearfix" style="margin-bottom: 5px;">
                        <p class="fl">预约</p>
                        <p class="fr">统计报表</p>
                      </li>
                      <li class="clearfix" style="margin-bottom: 5px;">
                        <p class="fl">放贷</p>
                        <p class="fr">视频监管</p>
                      </li>
                      <li class="clearfix" style="margin-bottom: 5px;">
                        <p class="fl">货转</p>
                        <p class="fr">业务查询</p>
                      </li>
                    </ul>
                    <div>
                      <img style="width: 42px; height: 42px; cursor: pointer;position: absolute;right: 15px;bottom: 20px;" src="//static.yiteng288.com/e-comm/pages/winsway/public/160341972174647873502_84_84.png" alt="">
                    </div>
                  </div>
                </div>
              </a>
            </div>
            <div class="owl-item">
              <a href="//login.yiteng288.com/saaslogin/index" target="_blank">
                <div class="pic">
                  <img class="big_pic" src="//static.yiteng288.com/e-comm/pages/winsway/public/160341972219392132832_768_456.png" alt="">
                  <img src="//static.yiteng288.com/e-comm/pages/winsway/public/160341972188908816255_152_152.png" class="icon" alt="">
                </div>
                <div style="padding: 40px 20px;">
                  <div>
                    <p style="font-size: 24px; text-align: left; color: #262634;">货主服务</p>
                  </div>
                  <div style="margin-top: 20px;display: flex;justify-content: space-between;align-items: flex-end;">
                    <ul class="wisdom-list">
                      <li class="clearfix" style="margin-bottom: 5px;">
                        <p class="fl">物流过程可视</p>
                      </li>
                      <li class="clearfix" style="margin-bottom: 5px;">
                        <p class="fl">核心数据采集</p>
                      </li>
                      <li class="clearfix" style="margin-bottom: 5px;">
                        <p class="fl">放行干预</p>
                      </li>
                      <li class="clearfix" style="margin-bottom: 5px;">
                        <p class="fl">业务协同</p>
                      </li>
                    </ul>
                    <div>
                      <img style="width: 42px; height: 42px; cursor: pointer;position: absolute;right: 15px;bottom: 20px;" src="//static.yiteng288.com/e-comm/pages/winsway/public/160341972174647873502_84_84.png" alt="">
                    </div>
                  </div>
                </div>
              </a>
            </div>
            <div class="owl-item">
              <a href="//login.yiteng288.com/saaslogin/index" target="_blank">
                <div class="pic">
                  <img class="big_pic" src="//static.yiteng288.com/e-comm/pages/winsway/public/160341972231945731486_768_456.png" alt="">
                  <img src="//static.yiteng288.com/e-comm/pages/winsway/public/160341972195067200091_152_152.png" class="icon" alt="">
                </div>
                <div style="padding: 40px 20px;">
                  <div>
                    <p style="font-size: 24px; text-align: left; color: #262634;">金融机构</p>
                  </div>
                  <div style="margin-top: 20px;display: flex;justify-content: space-between;align-items: flex-end;">
                    <ul class="wisdom-list">
                      <li class="clearfix" style="margin-bottom: 5px;">
                        <p class="fl">物流过程可视</p>
                      </li>
                      <li class="clearfix" style="margin-bottom: 5px;">
                        <p class="fl">核心数据采集</p>
                      </li>
                      <li class="clearfix" style="margin-bottom: 5px;">
                        <p class="fl">放行干预</p>
                      </li>
                    </ul>
                    <div>
                      <img style="width: 42px; height: 42px; cursor: pointer;position: absolute;right: 15px;bottom: 20px;" src="//static.yiteng288.com/e-comm/pages/winsway/public/160341972174647873502_84_84.png" alt="">
                    </div>
                  </div>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
export default {

}
</script>

<style scoped>
@import '../style/common.css';
.banner {
  width: 100%;
  height: 420px;
  margin: 0 auto;
  background: url('//static.yiteng288.com/e-comm/pages/winsway/public/160341972144112299934_1920_420.png') no-repeat;
}
.main {
  width: 1184px;
  padding: 60px 0;
  margin: 0 auto;
}
.owl-item {
  width: 384px;
  display: inline-block;
  margin-right: 15px;
  cursor: pointer;
  box-shadow: 0px 2px 30px 0px rgba(107, 110, 129, 0.3);
  border-radius: 8px;
  position: relative;
}
.pic {
  position: relative;
}
.big_pic {
  width: 100%;
  height: 228px;
}
.icon {
  position: absolute;
  left: 10px;
  bottom: -38px;
  width: 76px;
  height: 76px;
}
.wisdom-list {
  width: 160px;
}
.wisdom-list li p {
  color: #6C6B82;
  font-size: 16px;

}
</style>